import { useContext } from 'react';

import MenuManagementContext from 'context/MenuManagementContext';

export const useMenuManagement = () => useContext(MenuManagementContext);
